import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import { PageHero, Icon, Button } from '../../components/ui';

const slugify = (s = '') => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const PrivacyPolicy = () => {
  const { t } = useTranslation();


  const sections = [
    {
      title: t('1. Information We Collect'),
      content: t('We collect personal information that you voluntarily provide to us when you register on the website, express an interest in obtaining information about us or our products and services, participate in activities on the website, or otherwise when you contact us. The personal information we collect may include names, email addresses, phone numbers, and payment information.'),
      icon: 'database'
    },
    {
      title: t('2. How We Use Your Information'),
      content: t('We use the information we collect to provide, maintain, and improve our services, to develop new ones, and to protect AyodhyaDham.info and our users. We also use this information to offer you tailored content and to help us understand the effectiveness of our services.'),
      icon: 'eye'
    },
    {
      title: t('3. How We Share Your Information'),
      content: t('We do not share your personal information with third parties except as described in this privacy policy. We may share your personal information with our service providers who process your information to provide services to us or on our behalf. We have contracts with our service providers that prohibit them from sharing your information with anyone else or using it for any other purpose.'),
      icon: 'shield-check'
    },
    {
      title: t('4. Data Security'),
      content: t('We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.'),
      icon: 'lock'
    },
    {
      title: t('5. Data Retention'),
      content: t('We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law.'),
      icon: 'trash-2'
    },
    {
      title: t('6. Your Privacy Rights'),
      content: t('You have the right to access, update, or delete the information we have on you. Whenever made possible, you can access, update, or request deletion of your personal information directly within your account settings section. If you are unable to perform these actions yourself, please contact us to assist you.'),
      icon: 'shield-check'
    },
    {
      title: t('7. Updates to This Policy'),
      content: t('We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last Updated" date.'),
      icon: 'database'
    },
    {
      title: t('8. Contact Us'),
      content: t('If you have any questions about this privacy policy, please contact us at privacy@ayodhyadham.info.'),
      icon: 'shield-check'
    }
  ];

  return (
    <>
      <SEO
        title="Privacy Policy"
        description="How AyodhyaDham.info collects, uses, stores and protects your personal information."
        canonicalUrl="/privacy"
      />
      <PageHero
        compact
        crumbs={[{ label: t('Home'), to: '/' }, { label: t('Privacy Policy') }]}
        title={t('Privacy Policy')}
        subtitle={t('How we collect, use and protect your information')}
      />

      <div className="container content-wrap">
        <div className="legal">
          <nav className="legal__nav" aria-label={t('On this page')}>
            {sections.map((s) => (
              <a key={s.title} href={`#${slugify(s.title)}`}>{s.title}</a>
            ))}
          </nav>

          <div className="content">
            <p className="legal__updated">
              <Icon name="shield-check" size={15} style={{ verticalAlign: 'text-bottom', marginRight: 6, color: 'var(--primary)' }} />
              {t('Last updated')}: {t('6 September 2026')}
            </p>

            <div className="prose">
              {sections.map((s) => (
                <section key={s.title} id={slugify(s.title)}>
                  <h2>{s.icon && <Icon name={s.icon} size={20} style={{ verticalAlign: 'baseline', marginRight: 8, color: 'var(--primary)' }} />}{s.title}</h2>
                  <p>{s.content}</p>
                </section>
              ))}
            </div>

            <div className="card card--pad" style={{ marginTop: 32, background: 'var(--surface-2)' }}>
              <h3 className="h-card" style={{ marginBottom: 8 }}>{t('Questions about this page?')}</h3>
              <p className="small muted" style={{ marginBottom: 14 }}>{t('Write to us and our team will get back to you.')}</p>
              <Button size="sm" variant="outline" to="/contact" icon={<Icon name="arrow-right" size={14} />}>{t('Contact Us')}</Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
